export default __webpack_public_path__ + "static/media/jhonathan-osorio-at-caq-soccer-43-of-43.6753b63c.jpeg";